// ** React Imports
import { SyntheticEvent, useState } from 'react'

// ** MUI Imports
import Avatar from '@mui/material/Avatar'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import { useSelector, useDispatch } from 'react-redux'
import { Popover } from '@mui/material'
import { RootState } from '../../../setup'
import { handleLogout } from '../auth/Logout'
import { useHistory } from 'react-router-dom'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded'
import moment from 'moment'

const UserDropdown = () => {
  // ** States
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const history = useHistory()
  // ** Hooks
  const dispatch = useDispatch()

  const handleDropdownClose = (url?: string) => {
    if (url) {
      history.push(url)
    }
    setAnchorEl(null)
  }

  const onLogoutClick = () => {
    handleDropdownClose()
    handleLogout(dispatch)

    // Use window.location.replace instead of history.push to ensure clean URL navigation
    // This will remove any existing query parameters and create a fresh history entry
    window.location.replace('/agent-application/login')
  }
  const responseUser: any = useSelector((state: RootState) => state.authUser.authUser)
  // eslint-disable-next-line
  const [open, setOpen] = useState(false)

  const handleClickAway = () => {
    setOpen(false)
  }

  const handleOpen = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }
  let fullName
  let lastLoginDate
  let nameInitials
  if (responseUser) {
    fullName = responseUser.firstName + ' ' + responseUser.lastName
    lastLoginDate = responseUser.lastLogin
    nameInitials = responseUser.firstName?.slice(0, 1) + responseUser?.lastName?.slice(0, 1) || ''
  } else {
    fullName =
      JSON.parse(localStorage.getItem('userDetails') || '')?.firstName +
      ' ' +
      JSON.parse(localStorage.getItem('userDetails') || '')?.lastName
    lastLoginDate = JSON.parse(localStorage.getItem('userDetails') || '')?.lastLogin
    nameInitials =
      JSON.parse(localStorage.getItem('userDetails') || '')?.firstName?.slice(0, 1) +
        JSON.parse(localStorage.getItem('userDetails') || '')?.lastName?.slice(0, 1) || ''
  }

  return (
    <>
      <Badge
        overlap='circular'
        onClick={handleOpen}
        sx={{ ml: 2, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Avatar
          alt={`${nameInitials}`}
          sx={{
            width: 40,
            height: 40,
            background: '#fff',
            border: '2px solid var(--secondary-color)',
            color: 'var(--secondary-color)',
            fontWeight: 'bold',
          }}
          // src='/images/avatars/user.png'
          src={'CR'}
        />
        <Box
          className={'mobileHide'}
          sx={{
            ml: 3,
            display: 'flex',
            flexDirection: 'column',
            padding: '4px 0',
            marginLeft: '10px',
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              color: '#000000',
              fontSize: '12px',
            }}
          >
            {fullName || ''}
          </Typography>
          <Typography sx={{ color: '#A4B3A9', fontSize: '11px' }} variant='body2' gutterBottom>
            {lastLoginDate && 'Last Login Date: ' + moment(lastLoginDate).format('DD MMM YYYY')}
          </Typography>
        </Box>
        <KeyboardArrowDownRoundedIcon sx={{ color: '#000000', ml: 2 }} />
      </Badge>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClickAway}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={onLogoutClick}
          className='navbar-links'
        >
          <LogoutRoundedIcon sx={{ color: '#3a3541de', mr: 1 }} />
          <Typography sx={{ color: '#3a3541de' }}>Logout</Typography>
        </Box>
      </Popover>
    </>
  )
}

export default UserDropdown
